// HtmlComponent.tsx
import React from 'react';
import { Box } from '@mui/material';

interface HtmlComponentProps {
  htmlContent: string;
}

const HtmlComponent: React.FC<HtmlComponentProps> = ({ htmlContent }) => {
  return (
    <Box
      sx={{
        maxHeight: '400px',
        overflowY: 'auto',
        p: 2,
        border: '1px solid #ccc',
        // Каскадная стилизация HTML-тегов внутри Box
        '& h1': { typography: 'h4', mb: 2 },
        '& p': { typography: 'body1', mb: 1 },
        '& li': { typography: 'body1' },
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Box>
  );
};

export default HtmlComponent;